// src/components/RealTimeData.js
import React, { useEffect } from 'react';
import io from 'socket.io-client';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {env} from '../config/env';
import { useTranslation } from 'react-i18next';

// Retrieve the token from localStorage
const getToken = () => {
  return localStorage.getItem('token');
};

const RealTimeData = ({ isAuthenticated }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!isAuthenticated || !env.enableRealtime) {
      return undefined;
    }

    const token = getToken();

    if (!token) {
      console.error('No token found, cannot establish Socket.IO connection.');
      return;
    }

    // Initialize Socket.IO client with token
    const socket = io(env.socketServerUrl, {
      auth: {
        token: `Bearer ${token}`,
      },
      transports: ['websocket', 'polling'],
      withCredentials: false,
    });

    socket.on('connect', () => {
      console.log('Connected to SocketIO server');
      toast.success(t('realtime.connected'));
    });

    socket.on('trade_signal', (data) => {
      toast.info(t('realtime.signal', { signal: data.signal, symbol: data.symbol }));
    });

    socket.on('connect_error', (err) => {
      console.error('Connection error:', err.message);
      toast.error(t('realtime.connectionError', { message: err.message }));
    });

    socket.on('disconnect', (reason) => {
      console.log(`Disconnected from SocketIO server: ${reason}`);
      if (reason === 'io server disconnect') {
        socket.connect();
      }
      toast.warn(t('realtime.disconnected'));
    });

    return () => {
      socket.disconnect();
      console.log('Socket.IO connection closed.');
    };
  }, [isAuthenticated, t]);

  return <ToastContainer />;
};

export default RealTimeData;
